<template>
  <div>
    <template v-if="ticket.pagos.length > 0">
      <vue-tabs style="margin-top: 200px">
        <v-tab title="Tickets">
          <table class="table tableTickets table-borderless">
            <tbody>
              <tr class="headerTicket">
                <td colspan="3">
                  <h5 style="margin-bottom: 0">
                    <i :class="getClassEstado(ticket.status)"></i>
                    {{ ticket.workerName }} |
                    {{ getEstado(ticket) }}
                    {{ ticket.date | parseDte }}h

                    <template v-if="ticket.status == 'C'">
                      <small style="float: right">Nº {{ ticket.code }}</small>
                    </template>

                    <template v-if="ticket.account != 0">
                      <span class="account">#{{ ticket.account }}</span>
                    </template>
                    <span>
                      <i class="fa fa-user" v-if="ticket.clientName != ' '"></i>
                      {{ ticket.clientName }}
                      <template v-if="ticket.name">
                        <span :class="[
                          ticket.name != '' && ticket.status == 'N'
                            ? 'cuentaAnulada'
                            : 'account',
                        ]">{{ ticket.name }}</span>
                      </template>
                      <template v-if="ticket.numIssues > 0">
                        <button @click="openModal()" class="btn cuentaIncidencia">
                          {{ $t("incidencias") }}
                          <span class="badge badge-light">{{
                            ticket.numIssues
                          }}</span>
                        </button>

                        <!--<span  class="cuentaIncidencia">
                             {{$t("incidencias")}}
                             <span class="badge badge-light">{{ticket.numIssues}}</span>
                         </span>-->
                      </template>
                    </span>
                  </h5>
                </td>
              </tr>
              <tr class="headerCambio" v-if="
                ticket.status == 'C' &&
                (ticket.paidType == 'E' || ticket.paidType == 'A')
              ">
                <td colspan="3">
                  <span v-if="ticket.paidType == 'E'">
                    {{ $t("entregado") }}:
                    <span class="text-success">{{ ticket.committed | currency }}
                    </span>
                    <span class="subTotal" v-if="ticket.status == 'C' && ticket.pagoSaldo != 0">{{
                      ticket.nombreProductoPagoSaldo }}: {{
                        ticket.pagoSaldo | currency }}</span>
                  </span>
                  <span v-else>
                    {{ $t("entregado") }}:
                    <span class="text-success">{{
                      (ticket.committed -
                        ticket.amountTarjeta -
                        ticket.amountCheque)
                      | currency
                    }}
                    </span>
                  </span>
                  <span v-if="ticket.paidType == 'E'">
                    | {{ $t("cambio") }}:
                    <span class="text-primary" v-if="ticket.committed > 0">
                      {{ (ticket.committed - ticket.total) | currency }}
                    </span>
                    <span class="text-primary" v-else>{{ 0 | currency }}</span>
                  </span>
                  <span v-else>
                    | {{ $t("cambio") }}:
                    <span class="text-primary" v-if="
                      ticket.committed -
                      ticket.amountTarjeta -
                      ticket.amountCheque >
                      0
                    ">
                      {{
                        (ticket.committed -
                          ticket.amountTarjeta -
                          ticket.amountCheque -
                          ticket.amountEfectivo)
                        | currency
                      }}
                    </span>
                    <span class="text-primary" v-else>{{
                      0 | currency
                    }}</span>
                    <!--<template v-if="ticket.mostrarPropina">
                      <span>
                        {{ $t('propina')}}
                      </span>
                      <span class="text-warning">
                        {{ ticket.propina | currency }}
                      </span>
                    </template>-->
                  </span>
                </td>
              </tr>
              <tr class="headerAvanzado" v-if="ticket.paidType == 'A' && ticket.status == 'C'">
                <td colspan="3">
                  {{ $t("efectivo") }}: {{ ticket.amountEfectivo | currency }} |
                  <span v-if="!ticket.nameTarjeta">{{ $t("tarjeta") }}:
                    {{ ticket.amountTarjeta | currency }} |</span>
                  <span v-else>{{ ticket.nameTarjeta }}:
                    {{ ticket.amountTarjeta | currency }} |</span>
                  <span v-if="!ticket.nameCheque">{{ $t("cheque") }}: {{ ticket.amountCheque | currency }}
                  </span>
                  <span v-else>{{ ticket.nameCheque }}:
                    {{ ticket.amountCheque | currency }}</span>
                  <!--<template v-if="ticket.mostrarPropina">
                      <span>
                        {{ $t('propina')}}
                      </span>
                      <span class="text-warning">
                        {{ ticket.propina | currency }}
                      </span>
                    </template>-->
                </td>
              </tr>
              <tr class="headerDetails" v-for="detail in ticket.details">
                <template v-if="ticket.status == 'X'">
                  <td>{{ $t("cambio") }}</td>
                  <td></td>
                </template>
                <template v-else-if="ticket.status == 'R'">
                  <td>{{ $t("retirada") }}</td>
                  <td></td>
                </template>
                <template v-else-if="ticket.status == 'G'">
                  <td>
                    {{ detail.name }}
                    <span v-if="detail.textRate">{{ detail.textRate }}</span>
                  </td>
                  <td></td>
                </template>
                <template v-else>
                  <td style="width: 45%">
                    <span class="uds"><template v-if="detail.askWeight">{{ detail.units.toFixed(3) }}
                        kg</template><template v-else>{{ detail.units }}x</template></span>
                    {{ detail.name }}
                    <ul v-if="detail.subproduct.length > 0">
                      <li v-for="sub in detail.subproduct">
                        <span v-if="sub.tipo == 'B'">
                          <!-- ({{ sub.estado == 'SIN BASE' ? $t('sinBase') : $t('base') }}) -->
                          ({{ $t("base") }})
                        </span>
                        <span v-if="sub.tipo == 'O'">
                          ({{ $t("opcional") }})
                        </span>
                        <span v-if="sub.tipo == 'E'">
                          ({{ $t("extra") }})
                        </span>
                      </li>
                    </ul>
                    <span v-if="detail.textRate">{{ detail.textRate }}</span>
                  </td>
                  <td align="right" style="width: 100px">
                    {{ detail.price | currency }}
                  </td>
                </template>

                <td align="right" style="width: 100px">
                  {{ detail.amount | currency }}
                </td>
              </tr>

              <template v-if="ticket.status === 'P'">
                <tr class="headerTotal">
                  <td align="right" style="width: 100px" colspan="3">
                    {{ $t("Subtotal") }}: {{ ticket.total | currency }}
                  </td>
                </tr>
                <tr class="headerTotal">
                  <td align="right" style="width: 100px" colspan="3">
                    {{ $t("pagosACuenta") }}: {{ getTotalPagos | currency }}
                  </td>
                </tr>
                <tr class="headerTotal">
                  <td align="right" style="width: 100px" colspan="3">
                    <strong>
                      {{ $t("total") }}:
                      {{ (ticket.total - getTotalPagos) | currency }}</strong>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="headerTotal">
                  <td align="right" style="width: 100px" colspan="3">
                    <strong>
                      {{ $t("total") }}: {{ ticket.total | currency }}</strong>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-tab>
        <v-tab title="Pagos">
          <table class="table tableTickets table-borderless">
            <tbody>
              <tr class="headerTicket">
                <td>
                  <h5>{{ $t("operario") }}</h5>
                </td>
                <td>
                  <h5>{{ $t("tipo") }}</h5>
                </td>
                <td>
                  <h5>{{ $t("fecha") }}</h5>
                </td>
                <td>
                  <h5>{{ $t("importe") }}</h5>
                </td>
              </tr>
              <tr class="headerDetails" v-for="pagos in ticket.pagos">
                <td style="width: 100px">{{ pagos.nameWorker }}</td>
                <td style="width: 100px">
                  <template v-if="pagos.tipo === 'E'">{{
                    $t("efectivo")
                  }}</template><template v-else-if="pagos.tipo === 'T'">{{
                      $t("tarjeta")
                    }}</template><template v-else>{{ $t("cheque") }}</template>
                </td>
                <td style="width: 100px">{{ pagos.fecha | parseDate }}</td>
                <td style="width: 100px">{{ pagos.importe | currency }}</td>
              </tr>

              <tr class="headerTotal">
                <td align="right" style="width: 100px" colspan="4">
                  <strong>{{ $t("total") }}: {{ getTotalPagos | currency }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </v-tab>
      </vue-tabs>
    </template>
    <template v-else>
      <table class="table tableTickets table-borderless">
        <tbody>
          <tr class="headerTicket">
            <td colspan="3">
              <h5 class="espaciado">
                <i :class="getClassEstado(ticket.status)"></i>
                {{ ticket.workerName }}
                {{ getEstado(ticket) }}
                {{ ticket.date | parseDte }}h


                <template v-if="ticket.status == 'C'">
                  <small style="float: right">Nº {{ ticket.code }}</small>
                </template>

                <template v-if="ticket.account != 0">
                  <span class="account">#{{ ticket.account }}</span>
                </template>
                <span>
                  <i class="fa fa-user" v-if="ticket.clientName != ' '"></i>
                  {{ ticket.clientName }}
                  <template v-if="ticket.name">
                    <span :class="[
                      ticket.name != '' && ticket.status == 'N'
                        ? 'cuentaAnulada'
                        : 'account',
                    ]">{{ ticket.name }}</span>
                  </template>
                  <template v-if="ticket.numIssues > 0">
                    <button @click="openModal()" class="btn cuentaIncidencia">
                      {{ $t("incidencias") }}
                      <span class="badge badge-light">{{
                        ticket.numIssues
                      }}</span>
                    </button>

                    <!-- <span  class="cuentaIncidencia">
                             {{$t("incidencias")}}
                             <span class="badge badge-light">{{ticket.numIssues}}</span>
                    </span> -->
                  </template>
                </span>
              </h5>
            </td>
          </tr>
          <tr>
            <td colspan="3" v-if="ticket.operarioAbre"
              style="font-size: 1em; padding-bottom:4px; padding-top:4px;border-right: 1px dotted #c3d4c3;">
              <i class="fa fa-user" aria-hidden="true" style="cursor:default"></i>
              {{ $t("operarioApertura") }}: {{ ticket.operarioAbre }}
            </td>
          </tr>
          <tr>
            <td v-if="ticket.tiempo_inicio"
              style="font-size: 1em; padding-bottom:4px; padding-top:4px;border-right: 1px dotted #c3d4c3;">
              <i class="fas fa-clock" aria-hidden="true" style="cursor:default"></i>
              {{ $t("horaDeApertura") }}: {{ ticket.tiempo_inicio | parseMin }}h
            </td>
          </tr>
          <tr>
            <td colspan="3" v-if="ticket.num_comensales"
              style="font-size: 1em; padding-bottom:4px; padding-top:4px;border-right: 1px dotted #c3d4c3;">
              <i class="fas fa-user-group" aria-hidden="true" style="cursor:default"></i>
              {{ $t("nDeComensales") }}: {{ ticket.num_comensales }}
            </td>
          </tr>
          <tr>
            <td v-if="ticket.proveedor"
              style="font-size: 1.25em; padding-bottom:4px; padding-top:4px; border-right: 1px dotted #c3d4c3;">
              <i class="fa fa-cubes" aria-hidden="true" style="cursor:default; 
                color: brown;"></i>
              {{ ticket.proveedor }}
            </td>
          </tr>
          <tr>
            <td v-if="ticket.repartidorName" style="font-size: 1em; padding-bottom:4px; padding-top:4px;">
              <img style="padding-bottom:2px; padding-right:0px; cursor:default"
                src="https://img.icons8.com/fluency-systems-filled/16/000000/motorcycle-delivery-single-box.png" />
              {{ $t("repartidor") }}: {{ ticket.repartidorName }}
            </td>
          </tr>
          <tr>
            <td v-if="ticket.horaRepartidorAsignado > 0" style="font-size: 1em; padding-bottom:4px; padding-top:4px;">
              <i class="fas fa-user-clock"></i>
              {{ $t("horaRepartidorAsignado") }}:
              {{ ticket.horaRepartidorAsignado | parseMin }}h
            </td>
          </tr>
          <tr class="headerCambio" v-if="
            ticket.status == 'C' &&
            (ticket.paidType == 'E' || ticket.paidType == 'A')
          ">
            <td colspan="3">
              <span v-if="ticket.paidType == 'E'">
                {{ $t("entregado") }}:
                <span class="text-success">{{ ticket.committed | currency }}
                </span>
              </span>
              <span v-else>
                {{ $t("entregado") }}:
                <span class="text-success">{{ ticket.committed | currency }}
                </span>
              </span>
              <span v-if="ticket.paidType == 'E'">
                | {{ $t("cambio") }}:
                <span class="text-primary" v-if="ticket.committed > 0">
                  {{ (ticket.committed - ticket.total) | currency }}
                </span>
                <span class="text-primary" v-else>{{ 0 | currency }}</span>
              </span>
              <span v-else>
                | {{ $t("cambio") }}:
                <span class="text-primary" v-if="ticket.committed - ticket.amountEfectivo > 0">
                  {{ (ticket.committed - ticket.amountEfectivo) | currency }}
                </span>
                <span class="text-primary" v-else>{{ 0 | currency }}</span>
              </span>
              <template v-if="ticket.mostrarPropina && ticket.propina > 0">
                <span>
                  | {{ $t('propina') }}
                </span>
                <span class="text-warning">
                  {{ ticket.propina | currency }}
                </span>
              </template>
              <span v-if="ticket.status == 'C' && ticket.pagoSaldo != 0"> | {{ ticket.nombreProductoPagoSaldo }}: <span
                  class="text-primary">{{ ticket.pagoSaldo | currency }}</span></span>
            </td>
          </tr>
          <tr class="headerCambio" v-if="
            ticket.paidType == 'T' && ticket.mostrarPropina && ticket.propina > 0">
            <td colspan="3">
              <span>
                {{ $t('propina') }}
              </span>
              <span class="text-warning">
                {{ ticket.propina | currency }}
              </span>
            </td>
          </tr>
          <tr class="headerAvanzado" v-if="ticket.paidType == 'A' && ticket.status == 'C'">
            <td colspan="3">
              {{ $t("efectivo") }}: {{ ticket.amountEfectivo | currency }} |
              <span v-if="!ticket.nameTarjeta">{{ $t("tarjeta") }}:
                {{ ticket.amountTarjeta | currency }} |

                <template v-if="ticket.mostrarPropina && ticket.propina > 0">
                  <span>
                    | {{ $t('propina') }}
                  </span>
                  <span class="text-warning">
                    {{ ticket.propina | currency }} |
                  </span>
                </template>
              </span>
              <span v-else>{{ ticket.nameTarjeta }}:
                {{ ticket.amountTarjeta | currency }} |</span>
              <span v-if="!ticket.nameCheque">{{ $t("cheque") }}:
                {{ ticket.amountCheque | currency }} |
                <template v-if="ticket.mostrarPropina && ticket.propina > 0">
                  <span>
                    | {{ $t('propina') }}
                  </span>
                  <span class="text-warning">
                    {{ ticket.propina | currency }} |
                  </span>
                </template>
              </span>
              <span v-else>{{ ticket.nameCheque }}:
                {{ ticket.amountCheque | currency }}</span>
              <template v-if="ticket.mostrarPropina && ticket.propina > 0">
                <span>
                  | {{ $t('propina') }}
                </span>
                <span class="text-warning">
                  {{ ticket.propina | currency }}
                </span>
              </template>
            </td>
          </tr>
          <tr class="headerDetails" v-for="detail in ticket.details">
            <template v-if="ticket.status == 'X'">
              <td>{{ $t("cambio") }}</td>
              <td></td>
            </template>
            <template v-else-if="ticket.status == 'R'">
              <td>{{ $t("retirada") }}</td>
              <td></td>
            </template>
            <template v-else-if="ticket.status == 'G'">
              <td>
                {{ detail.name }}
                <span v-if="detail.textRate">{{ detail.textRate }}</span>
              </td>
              <td></td>
            </template>
            <template v-else>
              <td style="width: 45%">
                <span class="uds"><template v-if="detail.askWeight">{{ detail.units.toFixed(3) }} kg</template><template
                    v-else>{{ detail.units }}x</template></span>
                {{ detail.name }}
                <ul v-if="detail.subproduct.length > 0">
                  <li v-for="sub in detail.subproduct">
                    <!-- {{sub.name}} -->
                    {{ sub.estado === 'SIN BASE' ? 'SIN ' + sub.name : sub.name }}
                    <span v-if="sub.tipo == 'B'">
                      <!-- ({{ sub.estado == 'SIN BASE' ? $t('sinBase') : $t('base') }}) -->
                      ({{ $t("base") }})
                    </span>
                    <span v-if="sub.tipo == 'O'">
                      ({{ $t("opcional") }})
                    </span>
                    <span v-if="sub.tipo == 'E'">
                      ({{ $t("extra") }})
                    </span>
                  </li>
                </ul>
                <span v-if="detail.textRate">{{ detail.textRate }}</span>
              </td>
              <td align="right" style="width: 100px">
                {{ detail.price | currency }}
              </td>
            </template>
            <td align="right" style="width: 100px">
              {{ detail.amount | currency }}
            </td>
          </tr>

          <tr class="headerTotal">
            <td align="right" style="width: 100px" colspan="3">
              <p class="subTotal" v-if="ticket.status == 'C' && ticket.descuento < 0">{{ ticket.descuentoPorcentaje }}%
                Total Dto:
                {{ ticket.descuento | currency }}</p>
              <strong>{{ $t("total") }}: {{ ticket.total | currency }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <modal :name="'modal-incidencias' + ticket.id" :adaptive="true" :scrollable="true" height="auto"
      :clickToClose="true">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("incidencias") }}</h4>
        </div>
        <div class="modal-body" style="background-color: #f5f5f5">
          <pre>{{ ticket.issues }}</pre>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button class="btn btn-danger" @click="closeModalIncidencia(ticket.id)">
              <i class="fa fa-window-close"></i> {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Terms from "../GeneralViews/Terms";
import moment from "moment";
export default {
  components: { Terms },
  /* props: {ticket, 
           conDetalles: 
             {default: false, 
             type: boolean
             }
     },*/
  props: ["ticket"],
  data() {
    return {
      /* conBases:false,
       conExtra:false,
       conOpcionales:false,*/
    };
  },
  created() {
    //Con bases
    // this.getConfigTpv(95);
    //con Opcionales
    // this.getConfigTpv(96);
    //con Extras
    // this.getConfigTpv(97);
  },
  methods: {
    openModal(id) {
      this.$modal.show("modal-incidencias" + this.ticket.id);
    },
    getEstado(ticket) {
      var xstatus = "";

      switch (ticket.status) {
        case "C":
          if (ticket.paidType === "E") {
            xstatus = this.$t("cobrado") + " - " + this.$t("efectivo");
          } else if (ticket.paidType === "T") {
            xstatus = ticket.nameFormaPago
              ? this.$t("cobrado") + " - " + ticket.nameFormaPago
              : this.$t("cobrado") + " - " + this.$t("tarjeta");
          } else if (ticket.paidType === "C") {
            xstatus = ticket.nameFormaPago
              ? this.$t("cobrado") + " - " + ticket.nameFormaPago
              : this.$t("cobrado") + " - " + this.$t("cheque");
          } else if (ticket.paidType === "A") {
            xstatus = this.$t("cobrado") + " - " + this.$t("avanzado");
          } else {
            xstatus = this.$t("cobrado");
          }
          break;
        case "P":
          xstatus = this.$t("apuntado");
          break;
        case "A":
          xstatus = this.$t("aparcado");
          break;
        case "G":
          xstatus = this.$t("gasto");
          break;
        case "N":
          xstatus = this.$t("anulado");
          break;
        case "X":
          xstatus = this.$t("cambio");
          break;
        case "R":
          xstatus = this.$t("retirada");
          break;
      }

      return xstatus;
    },
    getClassEstado(status) {
      var statusClass = "";
      switch (status) {
        case "C":
          statusClass = "statusC fa fa-check-circle";
          break;
        case "P":
          statusClass = "statusP fa fa-map-pin";
          break;
        case "A":
          statusClass = "statusA fa fa-clock";
          break;
        case "G":
          statusClass = "statusG fa fa-shopping-cart";
          break;
        case "N":
          statusClass = "statusN fa fa-times-circle";
          break;
        case "X":
          statusClass = "statusX fa fa-exchange-alt";
          break;
        case "R":
          statusClass = "statusR fas fa-retweet";
          break;
      }

      return statusClass;
    },
    closeModalIncidencia(id) {
      this.$modal.hide("modal-incidencias" + id);
    },
  },
  computed: {
    getTotalPagos() {
      let total = 0;

      this.ticket.pagos.forEach(function (x) {
        total += x.importe;
      });

      return total;
    },
  }
};
</script>
<style scoped>
.espaciado {
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 1.5;
}

table {
  background-color: #fff;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  margin-bottom: 10px;
}

table tbody {
  padding: 5px;
}

.card-body {
  padding: 10px 15px;
}

.title {
  font-weight: bold;
}

tfoot tr td {
  font-size: 1.2em;
  color: #fff;
  text-shadow: 1px 1px #111;
  font-weight: bold;
}

.progress {
  height: 15px !important;
}

.statusC {
  color: rgb(0, 128, 64);
  font-size: 1.2em;
}

.statusG {
  color: rgb(0, 64, 128);
  font-size: 1.2em;
}

.statusA {
  color: rgb(64, 0, 64);
  font-size: 1.2em;
}

.statusP {
  color: rgb(255, 128, 0);
  font-size: 1.2em;
}

.statusX {
  color: rgb(128, 128, 0);
  font-size: 1.2em;
}

.statusN {
  color: rgb(128, 0, 0);
  font-size: 1.2em;
}

.statusR {
  color: red;
  font-size: 1.2em;
}

.headerTicket {
  border-bottom: 1px dotted #c3d4c3;
}

.headerTicket td {
  padding: 15px 15px;
  font-weight: bold;
}

.headerDetails tr {
  padding: 15px 15px;
}

.account {
  color: #fff;
  background-color: #428bca;
  padding: 6px;
}

.cuentaAnulada,
.cuentaIncidencia {
  background-color: #d2322d;
  color: #fff;
  font-size: 0.8em;
  padding: 6px;
}

.headerAvanzado {
  border-bottom: 1px dotted #c3d4c3;
}

.headerAvanzado td {
  padding: 6px 15px;
  color: darkgreen;
  font-size: 0.8em;
}

.headerCambio {
  border-bottom: 1px dotted #c3d4c3;
}

.headerCambio td {
  padding: 6px 15px;
  font-size: 0.8em;
}

.headerDetails td {
  padding: 6px 15px;
}

.headerDetails:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.headerTotal {
  border-top: 1px dotted #c3d4c3;
  font-size: 1.2em;
}

.headerTotal td {
  padding: 10px 15px;
}

.uds {
  color: #555;
  font-weight: bold;
}

.subTotal {
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Ticket.vue